import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { useContext } from 'react'

import { FormContext } from '../Contexts'
import { get } from 'lodash'

const SelectRegistered = ({
  name,
  label,
  options,
  required,
}: {
  name: string
  label: string
  options: { label: string; value?: string | number }[]
  required?: boolean
}) => {
  const { control, formState } = useContext(FormContext)
  const error = get(formState?.errors, name)

  return (
    <FormControl variant="standard" fullWidth required={required} error={!!error}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Controller
        render={({ field }) => (
          <Select fullWidth {...field}>
            {options.map(({ label, value }, index) => (
              <MenuItem key={index} value={value === undefined ? label : value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        )}
        name={name}
        control={control}
        defaultValue={''}
      />
      <Typography variant="inherit" color="red" align="left" style={{ marginTop: 10 }}>
        {error?.message?.toString()}
      </Typography>
    </FormControl>
  )
}

export { SelectRegistered }
